/// <amd-module name="typeahead/features/OverrideMinQueryLength" />
/// <amd-dependency path="jquery" name="$"/>

import {Experiment} from "typeahead/core/Experiment";
import {IExperimentalFeature} from "typeahead/core/IExperimentalFeature";
import {IMinQueryLengthOverrider} from "typeahead/core/IMinQueryLengthOverrider";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import * as StripingConfiguration from "typeahead/core/StripingConfiguration";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";

const configuration: IStripingConfiguration[] = [
    {
        clients: ["Flights.Search"],
        experiment: {
            id: 15335,
            name: "FSRP_uTA_MinQueryLength",
            value: 1,
        },
    },
];

export class OverrideMinQueryLength implements IExperimentalFeature, IMinQueryLengthOverrider {
    public getExperiments(): Experiment[] {
        return StripingConfiguration.getExperiments(configuration);
    }

    public overrideMinQueryLength(context: IContext): JQueryPromise<number> {
        const deferred: JQueryDeferred<number> = $.Deferred();
        ExecutionHelper.shouldExecute(context, configuration)
            .done((shouldExecute: boolean): void => {
                if (shouldExecute) {
                    // This plugin/feature overrides the minimal query length (minchar) to 1. Should the need arise to
                    // experiment with overriding to various values, this will need to be redesigned.
                    deferred.resolve(1);
                } else {
                    deferred.reject();
                }
            })
            .fail((): void => {
                deferred.reject();
            });
        return deferred.promise();
    }
}
